import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["formInputs", "template", "varietyItem", "varietySelect"];
  static values = {
    formClass: String,
    varieties: Array,
  };

  initialize() {
    console.log("VintageVarietiesController initialized");
  }

  connect() {
    console.log("VintageVarietiesController connected");
    console.log("Form class:", this.formClassValue);
    console.log("Form inputs target:", this.formInputsTarget);
    console.log("Template target:", this.templateTarget);
    // Initialize any existing variety selects
    this.varietySelectTargets.forEach((select) =>
      this.initializeSelect(select)
    );
  }

  addVariety(event) {
    event.preventDefault();
    const template = this.element.querySelector(
      "[data-vintage-varieties-target='template']"
    );
    const content = template.content.cloneNode(true);
    const newSelect = content.querySelector(
      "[data-vintage-varieties-target='varietySelect']"
    );
    this.initializeSelect(newSelect);
    this.formInputsTarget.appendChild(content);
  }

  removeVariety(event) {
    event.preventDefault();
    const item = event.target.closest(
      "[data-vintage-varieties-target='varietyItem']"
    );
    item.remove();
  }

  renderTemplate(template) {
    return template.replace(/\[\[\]/g, `[${this.getNextIndex()}]`);
  }

  getNextIndex() {
    const inputs = this.formInputsTarget.querySelectorAll(
      'input[name*="[variety_id]"]'
    );
    return inputs.length;
  }

  initializeSelect(select) {
    // Clear any existing options except the first (placeholder)
    while (select.options.length > 1) {
      select.remove(1);
    }

    // Add all varieties as options
    this.varietiesValue.forEach(([name, id]) => {
      const option = new Option(name, id);
      select.add(option);
    });
  }
}
